// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"7":"admin-dashboard","361":"panel-vendedores","444":"notifications-panel","448":"panel-tecnicos","509":"crear-work-order","881":"admin-panel"}[chunkId] + "." + {"7":"801765c5","361":"5fcb6fbd","444":"56847791","448":"f5b58c63","509":"7fcbf247","881":"df35a877"}[chunkId] + ".css";
};